"use client"
import { useEffect, useState } from "react";
import cn from "classnames";
import { fetchCMS } from "@/lib/cms";
import Styles from "./welcome.module.scss";
import { Button } from "./forms/index";

type SiteSettings = {
  welcomeCta: string;
  welcomeHeader: string;
  welcomeSub: string;
};

export const Welcome = ({ play }: { play: () => void } ) => {
  const [playbackAuthorized, setPlaybackAuthorized] = useState(false);
  const [curtainActive, setCurtainActive] = useState(true);
  const [welcomeContent, setWelcomeContent] = useState<SiteSettings | null>(null);

  const onWelcomeCurtainClick = () => {
    play();
    setPlaybackAuthorized(true);
  };

  const killCurtain = () => {
    if (playbackAuthorized) {
      setTimeout(setCurtainActive, 5000, false);
    }
  };

  const fetchSettings = async () => {
    const { data } = (await fetchCMS('site-setting', { populate: '[music][populate][youtube]=*', normalize: true })) as { data: SiteSettings };
    setWelcomeContent(data || null);
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    curtainActive &&
      <div onTransitionEnd={killCurtain} onClick={onWelcomeCurtainClick} className={cn( Styles.welcomeCurtain, { playbackAuthorized})}>
        <div className={Styles.copy}>
          {/* <Image
            className={Styles.bear}
            src="/surfing-bear.webp"
            alt="The California Roadhouse"
            sizes="(max-width: 768px) 100vw, 50vw"
            width={332}
            height={332}
            priority
          /> */}
          <div className={Styles.bearWrapper}>
            <video className={Styles.welcomeVideo} autoPlay loop muted playsInline>
              <source src="/Surfing-Bear.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <h1>{welcomeContent?.welcomeHeader || "The California Roadhouse"}</h1>
          <h3>{welcomeContent?.welcomeSub || "welcome to"}</h3>
          <Button onClick={onWelcomeCurtainClick} variant="secondary" size="xl">{welcomeContent?.welcomeCta || "Enter Roadhouse"}</Button>
        </div>
      </div>
  );
};
